import { render, staticRenderFns } from "./intelligentAgentConfig.vue?vue&type=template&id=38bc2694&scoped=true"
import script from "./intelligentAgentConfig.vue?vue&type=script&lang=js"
export * from "./intelligentAgentConfig.vue?vue&type=script&lang=js"
import style0 from "./intelligentAgentConfig.vue?vue&type=style&index=0&id=38bc2694&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc2694",
  null
  
)

export default component.exports